<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Template de factures</h1>
                    <p>Gestion des templates de facture</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.invoice-template.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un template</span>
                </li>
              </actions-dropdown>

            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" :tabs="tabsFilter" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

                <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                    <div class="datagrid-header">
                        <div>
                            <div></div>
                            <div class="picture"></div>
                            <div class="center">
                              <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div>
                              <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                            </div>
                            <div><span>Fichier</span></div>
                            <div><span>Scopes</span></div>
                            <div class="actions"></div>
                            <div></div>
                        </div>
                    </div>
                    <div class="datagrid-body">
                        <div v-for="item in resources" @dblclick="edit(item.id)"  v-bind:class="setClassDataRaw( 'weeboxcore.invoice-template.view', item.id )">
                            <div></div>
                            <div class="picture no-radius">
                                <figure>
                                  <img :src="$iconFolder + 'template.svg'"/>
                                </figure>
                            </div>
                            <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                            <div data-field="name"><strong class="highlight">{{ item.name }}</strong><p>{{ item.description }}</p></div>
                            <div><span v-if="item.file">{{ item.file.original_filename }}</span></div>
                            <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                            <div class="actions">
                                <ul>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.invoice-template.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                    <li v-if="$aclInterfaceValidator('weeboxcore.invoice-template.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                                </ul>
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import InvoiceTemplateService from './InvoiceTemplateService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
                tabsFilter: []
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return InvoiceTemplateService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/invoice-template/Index.vue